<template>
  <div class="event-details-box event-box-shadow p-24">
    <div class="event-registration-box event-box-shadow">
      <div class="event-rg-section">
        <div class="event-rg-avatar">
          <div class="event-rg-bg"></div>
          <div class="event-rg-img font-light"><img src="../../assets/icons/info-icon.svg" /></div>
        </div>
        <div>
          <h6>{{ headerLabel }}</h6>
          <p>{{ labels['ticket-label-already-registered-description'] }}</p>
          <button class="btn btn-primary" v-on:click="reloadPage">{{ labels['ticket-label-register-someone-else'] }}</button>
        </div>
      </div>
    </div>
  </div><!-- /.event-else-wrapper -->
</template>

<script>
export default {
  props: {
    user: { type: String, required: true },
    labels: { type: Object, required: true }
  },
  computed: {
    headerLabel() {
      return this.labels['ticket-label-already-registered'].replace('{firstname}', this.user);
    }
  },
  methods: {
    reloadPage: function () {
      window.location.reload();
    }
  }
}
</script>
